import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/lib/api";

const SiteContext = createContext({});

export const SiteProvider = ({ children }) => {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const settings = data || {};
  return <SiteContext.Provider value={settings}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
